// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel } from './eServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EntlibResponseEServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel {
    'data': Array<EServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel>;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EntlibResponseEServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Array<EServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel>"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return EntlibResponseEServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel.attributeTypeMap;
    }
}
